import React, { useEffect, useState } from "react";
import { CiFilter } from "react-icons/ci";
import { IoCheckmark } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { getPatientAction } from "../../Actions/PatientActions/PatientAction";
import { useNavigate } from "react-router-dom";
import { LuSendHorizonal } from "react-icons/lu";
import { FaRegEye } from "react-icons/fa6";
import SendInformation from "./SendInformation";
import LoadingPage from "../Loading/LoadingPage";
import ViewAllInfoModal from "../../Modal/AffirasOfSurgeryModal/ViewAllInfoModal";
import { CREATE_MEDICAL_SUPLIES_REQUEST } from "../../ActionType/MedicalSupliesTypes/MedicalSupliesTypes";
import Pagination from "../Pagination";

const AffiarsOfSurgeryPage = () => {
  const [isOpenSendModal, setIsOpenSendModal] = useState(false);
  const [isOpenViewAllModal, setIsOpenViewAllModal] = useState(false);
  const [patientId, setPatientId] = useState(null);
  const navigate = useNavigate();
  const th = [
    {
      label: "Code",
      name: "code",
    },
    {
      label: "full Name",
      name: "fullname",
    },
    {
      label: "Gender",
      name: "gender",
    },
    {
      label: "phone",
      name: "phone",
    },
    {
      label: "birth date",
      name: "birthDate",
    },
  ];
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);

  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const [indexx, setIndexx] = useState(null);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getPatientAction(
        page,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        [1, 2],
        [1],
        0
      )
    );
  }, [perPage]);
  const getPatient = useSelector((state) => state.getPatient);
  const { patients, total, loading } = getPatient;
  const onPageChange = (event) => {
    setPage(event.selected);

    dispatch(
      getPatientAction(
        event.selected + 1,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        [1, 2],
        [1],
        0
      )
    );
  };
  const [filter, setFilter] = useState({
    fullname: "",
    code: "",
    gender: "",
    phone: "",
    birthDate: "",
  });
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({
      ...filter,
      [name]: value,
    });
  };
  const handleSearch = () => {
    dispatch(
      getPatientAction(
        page,
        perPage,
        filter.fullname,
        filter.code,
        filter.gender,
        filter.phone,
        filter.birthDate,
        [1, 2],
        [1],
        0
      )
    );
    setIsOpenFilter(false)

  };
  const handleClearSearch = (name) => {
    const updateParams = { ...filter };
    updateParams[name] = "";
    setFilter(updateParams);
    dispatch(
      getPatientAction(
        page,
        perPage,
        updateParams.fullname,
        updateParams.code,
        updateParams.gender,
        updateParams.phone,
        updateParams.birthDate,
        [1, 2],
        [1],
        0
      )
    );
    setIsOpenFilter(false)
  };
  return (
    <>
    
        <div className="parent">
          <div className="flex justify-between items-center p-2">
            <div>
              <p className="font-bold">Affiars Of Surgery</p>
            </div>
          </div>
          {
            loading ?     <LoadingPage />: <div className={"parent-table  w-full"}>
            <div className=" overflow-y-auto" style={{ height: "70vh" }}>
              <table className="w-full  overflow-y-auto">
                <thead className="coustm-thead">
                  <tr>
                    <th className="coustm-th">#</th>
                    {th.map((th, index) => {
                      return (
                        <th className="coustm-th relative " key={index}>
                          <div className="flex justify-between items-center">
                            {th.label}
                            <div
                              className="parent-filter"
                              onClick={() => {
                                setIsOpenFilter(!isOpenFilter);
                                setIndexx(index);
                              }}
                            >
                              <CiFilter />
                            </div>
                          </div>
                          {index == indexx && isOpenFilter && (
                            <div className="parent-input-filter ">
                              <input
                                type="text"
                                className="p-2 text-black"
                                name={th.name}
                                onChange={handleFilterChange}
                                value={filter[th.name]}
                                placeholder={th.label}
                              />
                              <div className="fotter-filter mt-2">
                                <button
                                  className="btn-primary px-1.5 py-1 font-bold"
                                  onClick={handleSearch}
                                >
                                  <IoCheckmark />
                                </button>
                                <button onClick={()=>handleClearSearch(th.name)} className="btn-danger px-1.5 py-1">
                                  <RxCross2 />
                                </button>
                              </div>
                            </div>
                          )}
                        </th>
                      );
                    })}
                    <th className="coustm-th">Visits </th>
                    <th className="coustm-th">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {patients?.map((patient, index) => {
                    return (
                      <tr className="coustm-tr" key={index}>
                        <td className="coustm-td">{index + 1}</td>

                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.code}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.fullname}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.gender}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.phone}
                        </td>
                        <td className="coustm-td">
                          {" "}
                          {patient.patient_info.birth_date}
                        </td>
                        <td
                          onClick={() =>
                            navigate("/followUpVisit/" + patient.id)
                          }
                          className="coustm-td text-red-600 underline text-lg font-bold text-center"
                        >
                          {" "}
                          {patient.count_visits_with_approve}
                        </td>
                        <td className="coustm-td">
                          <div className="flex gap-2 items-center justify-center">
                            <button
                              title="Send"
                              className="text-indigo-500 text-lg hover:text-indigo-600 duration-300"
                              onClick={() => {
                                setIsOpenSendModal(true);
                                setPatientId(patient.id);
                              }}
                            >
                              <LuSendHorizonal />
                            </button>
                            <button
                              onClick={() => {
                                setIsOpenViewAllModal(true);
                                setPatientId(patient.id);
                              }}
                              title="Show"
                              className="text-teal-500 text-lg hover:text-teal-600 duration-300"
                            >
                              <FaRegEye />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
          }
         
          {total > 0 ? (
            <Pagination
              total={total}
              page={page}
              perPage={perPage}
              onPageChange={onPageChange}
              setPerPage={setPerPage}
            />
          ) : (
            ""
          )}
        </div>
      

      <div className="bottom-space"></div>
      {isOpenSendModal && (
        <SendInformation
          patientId={patientId}
          closeModal={() => {
            setIsOpenSendModal(false);
            dispatch({
              type: CREATE_MEDICAL_SUPLIES_REQUEST,
            });
          }}
        />
      )}

      {isOpenViewAllModal && (
        <ViewAllInfoModal
          patientId={patientId}
          closeModal={() => setIsOpenViewAllModal(false)}
        />
      )}
    </>
  );
};

export default AffiarsOfSurgeryPage;
